module.exports = __webpack_public_path__ + "da5ff18c3621487c951a63b09e727505.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/plus_redesign.png
// module id = 64
// module chunks = 0